import { useTranslation } from "react-i18next";
import { setLocale, SUPPORTED_LOCALES, type Locale } from "@/i18n";

const LABELS: Record<Locale, string> = {
  nl: "Nederlands",
  en: "English",
  ar: "العربية",
  tr: "Türkçe",
};

export function LocaleSwitcher() {
  const { i18n } = useTranslation();

  return (
    <select
      aria-label="Taal kiezen"
      value={i18n.language}
      onChange={(e) => setLocale(e.target.value as Locale)}
      className="text-sm px-2 py-1 border border-neutral-300 rounded-lg bg-white"
    >
      {SUPPORTED_LOCALES.map((loc) => (
        <option key={loc} value={loc}>
          {LABELS[loc]}
        </option>
      ))}
    </select>
  );
}
